/* eslint-disable @typescript-eslint/no-explicit-any */
import { DataSource, Order } from './EuroprocurementApiType';

export type FiltersToQuery = (
    filters: DataSource<any>['filters'],
    aditionalMatch?: Array<Record<string, unknown>>,
    orders?: DataSource<any>['orders'],
    ordersWithoutKeyword?: Array<string>,
) => string;

const filtersToElasticQuery: FiltersToQuery = (
    filters,
    aditionalMatch,
    orders,
    ordersWithoutKeyword = [],
) => {
    const query: any = {
        query: {
            bool: {
                must: [],
            },
        },
    };

    if (aditionalMatch) {
        query.query.bool.must.push(...aditionalMatch);
    }

    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(filters)) {
        if (Array.isArray(value)) query.query.bool.must.push({ terms: { [key]: value } });
        if (typeof value === 'boolean') query.query.bool.must.push({ match: { [key]: value } });
        if (typeof value === 'number') query.query.bool.must.push({ match: { [key]: value } });
        if (typeof value === 'string')
            query.query.bool.must.push({
                query_string: {
                    fields: [`${key}`],
                    query: `${value}`,
                },
            });
    }

    if (orders && orders.length > 0) {
        query.sort = orders.map((order: Order) => {
            const isDateField =
                order.field.toLowerCase().includes('date') ||
                order.field.toLowerCase().includes('createdat') ||
                order.field.toLowerCase().includes('updateat'); // on ne met pas "keyword" pour un champs date
            const field =
                isDateField || ordersWithoutKeyword.includes(order.field)
                    ? order.field
                    : `${order.field}.keyword`;

            const res = {
                [field]: {
                    order: order.value,
                },
            };

            return res;
        });
    }

    return JSON.stringify(query);
};

export default filtersToElasticQuery;
